import React from 'react';

import IncomingMsgShimmerComponent from './incomingMsgShimmerComponent';
import OutgoingMsgShimmerComponent from './outgoingMsgShimmerComponent';
import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './clientChatContainerShimmerComponent.css';

const ClientChatContainerShimmerComponent = () => {
  return (
    <div className="et-v2-client-chat-container-shimmer-container">
      <div className="et-cccsc-automatic-msg">
        <ShimmerComponent />
      </div>
      <div className="et-v2-cccsc-center-content-wrap">
        <IncomingMsgShimmerComponent />
        <OutgoingMsgShimmerComponent />
        <IncomingMsgShimmerComponent />
      </div>
      <div className="et-cccsc-input-field-btn-wrap">
        <div className="et-cccsc-ifb-input-field">
          <ShimmerComponent />
        </div>
        <div className="et-cccsc-ifb-btn">
          <ShimmerComponent />
        </div>
      </div>
    </div>
  );
};

export default ClientChatContainerShimmerComponent;
